"use client";

import React, { useState } from "react";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";

import type { Client } from "../../../../graphql/gql-types";
import type { Notifications } from "../sidebar/Sidebar";
import Banner from "#src/components/FixedHeaderBanner/Banner";

type AppProps = {
  clientCount: number;
  activeClient: Client;
  children: React.ReactNode;
  notifications: Notifications;
};

export default function App({
  clientCount,
  activeClient,
  notifications,
  children,
}: AppProps) {
  const [isSidebarOpen, toggleSideBar] = useState<boolean>(false);
  const expiryDateStr = process.env.NEXT_PUBLIC_MESSAGE_EXPIRY_DATE;
  const isBannerVisible =
    expiryDateStr && new Date() < new Date(expiryDateStr);


  return (
    <>
      {isBannerVisible && <Banner />}
      <div className={`flex h-screen overflow-hidden ${isBannerVisible ? "pt-16" : ""}`}>
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSideBar={toggleSideBar}
          notifications={notifications}
          allowed_to_trade={activeClient.allowed_to_trade}
        />

        <div className="flex flex-col flex-1 w-0">
          <Header
            activeClient={activeClient}
            showAccountSwitch={clientCount > 1}
            isSidebarOpen={isSidebarOpen}
            toggleSideBar={toggleSideBar}
          />
          <div className="overflow-y-scroll">{children}</div>
        </div>
      </div>
    </>
  );
}
